import { Component } from '@angular/core';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { SearchComponent } from '../../components/common/search/search.component';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { DateRangeModel } from '../../models/common/date.range';
import { IPage } from '../../models/common/paging';
import { AwardDto, CompetitorAwardsSearchModel, CompetitorAwardSearchStorage } from '../../models/competitors/competitor.models';
import { CompetitorAwardsService } from '../../services/competitor.awards.service';
import { BaseCompetitorsComponent } from './base.competitors.component';

@Component({
    selector: 'competitor-awards',
    template: require('./competitor.awards.component.html'),
    styles: [require('../filter.toggle.shared.css')]
})
export class CompetitorAwardsComponent extends SearchComponent<CompetitorAwardsSearchModel, AwardDto>{

    base: BaseCompetitorsComponent;
    awards: IPage<AwardDto>;
    publishedDate: DateRangeModel;
    competitorList: string[];
    supplierId: number;
    clicked: boolean;

    constructor(private readonly competitorService: CompetitorAwardsService, configuration: Configuration, helpers: Helpers, loggedInUserService: LoggedInUserService) {
        super(new CompetitorAwardsSearchModel(configuration), competitorService, helpers);
        this.publishedDate = new DateRangeModel();
        this.request.name = "";
        var user = loggedInUserService.getCurrentUser();
        this.supplierId = user.supplierId;
        this.clicked = false;
    }

    ngOnInit() {
        this.refresh();
    }

    refresh() {

        this.competitorService.getCompetitors().subscribe((response: string[]) => {
            this.competitorList = response;
        });

        const storedRequest = JSON.parse(localStorage.getItem('awardStore')) as CompetitorAwardSearchStorage;

        if (storedRequest) {
            this.request.name = storedRequest.awardedCompanyName;            
            if (storedRequest.publishedDate != null) {
                this.publishedDate.setMomentDatesFromStorage(storedRequest.publishedDate);
            }
            this.request.pageNumber = storedRequest.pageNumber;
            localStorage.removeItem('awardStore');
        }

        this.search();
    }

    search() {
        const publishedDateDto = this.publishedDate.convertDatesToDto();

        this.request.publishedDateFrom = publishedDateDto.startDate;
        this.request.publishedDateTo = publishedDateDto.endDate;

        var requestToStore = new CompetitorAwardSearchStorage(this.request);
        requestToStore.publishedDate = this.publishedDate.exportDatesForStorage();

        //localStorage.setItem('awardStore', JSON.stringify(requestToStore));

        return super.search();
    }

    public downloadCsv(): void {
        this.clicked = true;
        this.competitorService.downloadCsv(this.supplierId);
        this.clicked = false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/competitor.awards.component.ts